(() => {
  'use strict';
  const root = `${(document.body.dataset.root || '/').replace(/\/+$/, '')}/`;
  const cartURL = document.body.dataset.cartUrl || `${root}cart`;
  const drawerEnabled = document.body.dataset.cartDrawer === 'true';
  let cartBusy = false;
  let drawerOpener = null;
  let toastTimer;
  const toast = (text) => {
    const el = document.querySelector('[data-toast]');
    if (!el) return;
    el.textContent = text; el.hidden = false;
    clearTimeout(toastTimer); toastTimer = setTimeout(() => { el.hidden = true; }, 4500);
  };
  const setCount = (count) => {
    if (!Number.isFinite(count)) return;
    document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = String(count); });
  };
  const setError = (el, message) => { if (el) { el.textContent = message; el.hidden = !message; } };
  const showDrawer = () => {
    const dialog = document.getElementById('CartDrawer');
    if (!dialog || typeof dialog.showModal !== 'function') { window.location.assign(cartURL); return; }
    if (!dialog.open) dialog.showModal();
    dialog.querySelector('[data-close-cart]')?.focus();
  };
  const replaceDrawer = (html) => {
    if (typeof html !== 'string' || !html) return false;
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const fresh = parsed.getElementById('shopify-section-df-cart-drawer');
    const current = document.getElementById('shopify-section-df-cart-drawer');
    if (!fresh || !current || !fresh.querySelector('#CartDrawer')) return false;
    const dialog = current.querySelector('dialog');
    if (dialog?.open) { dialog.dataset.replacing = 'true'; dialog.close(); }
    current.replaceWith(fresh); return true;
  };
  async function openCart(trigger) {
    if (cartBusy) return;
    cartBusy = true; drawerOpener = trigger;
    trigger?.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(`${root}?section_id=df-cart-drawer`, { credentials: 'same-origin' });
      if (!response.ok || !replaceDrawer(await response.text())) throw new Error('cart unavailable');
      showDrawer();
    } catch { window.location.assign(cartURL); }
    finally { cartBusy = false; trigger?.removeAttribute('aria-busy'); }
  }
  function syncVariant(form, updateMedia = true) {
    const select = form.querySelector('[data-variant]');
    const option = select?.selectedOptions[0];
    if (!option) return;
    const available = option.dataset.available === 'true';
    const price = form.querySelector('[data-price]');
    if (price) price.textContent = option.dataset.price || '';
    const compare = form.querySelector('[data-compare]');
    if (compare) { compare.textContent = option.dataset.compare || ''; compare.hidden = option.dataset.sale !== 'true'; }
    const sale = form.querySelector('[data-sale]');
    if (sale) sale.hidden = option.dataset.sale !== 'true';
    const add = form.querySelector('[data-add]');
    if (add) { add.disabled = !available; const label = add.querySelector('[data-add-label]'); if (label) label.textContent = available ? 'أضف للسلة' : 'نفدت الكمية'; }
    const express = form.querySelector('[data-express]');
    if (express) express.hidden = !available;
    const qty = form.querySelector('[name="quantity"]');
    if (qty) {
      qty.min = option.dataset.min || '1'; qty.step = option.dataset.step || '1';
      if (option.dataset.max) qty.max = option.dataset.max; else qty.removeAttribute('max');
      const min = Number(qty.min); const max = qty.max ? Number(qty.max) : Infinity;
      qty.value = String(Math.min(max, Math.max(min, Number(qty.value) || min)));
    }
    document.querySelectorAll('[data-sticky-price]').forEach(el => { el.textContent = option.dataset.price || ''; });
    if (form.dataset.productPage === 'true') {
      const url = new URL(window.location.href); url.searchParams.set('variant', option.value); history.replaceState({}, '', url);
      if (updateMedia && option.dataset.media) showMedia(option.dataset.media);
    }
  }
  const galleries = new WeakMap();
  const reduceMotion = () => window.matchMedia?.('(prefers-reduced-motion: reduce)').matches || false;
  function setDemoSource(img, playing) {
    const source = playing && img.dataset.paused !== 'true' ? img.dataset.gif : img.dataset.poster;
    if (img.getAttribute('src') !== source) img.src = source;
  }
  function initializeGallery(gallery) {
    if (galleries.has(gallery)) return;
    const stage = gallery.querySelector('.gallery-stage');
    const items = [...stage.querySelectorAll('[data-gallery-item]')];
    if (!items.length) return;
    let active = -1, frame = 0;
    const select = (index) => {
      index = Math.max(0, Math.min(items.length - 1, index));
      if (index === active) return;
      active = index;
      items.forEach((item, i) => {
        const visible = i === active;
        item.setAttribute('aria-hidden', String(!visible));
        item.inert = !visible;
        if (!visible) item.querySelectorAll('video').forEach(video => video.pause());
        item.querySelectorAll('[data-demo-gif]').forEach(img => setDemoSource(img, visible));
      });
      gallery.querySelectorAll('[data-gallery-show]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.galleryShow === items[active].dataset.galleryItem));
      });
      gallery.querySelector('[data-gallery-status]').textContent = items[active].getAttribute('aria-label');
    };
    const goTo = (id, behavior = reduceMotion() ? 'auto' : 'smooth') => {
      const index = items.findIndex(item => item.dataset.galleryItem === id);
      if (index < 0) return;
      stage.scrollTo({left: index * stage.clientWidth, behavior});
      if (behavior === 'auto') select(index);
    };
    items.forEach(item => { item.hidden = false; });
    gallery.dataset.carouselReady = 'true';
    select(0);
    stage.addEventListener('scroll', () => {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        if (stage.clientWidth) select(Math.round(stage.scrollLeft / stage.clientWidth));
      });
    }, {passive: true});
    stage.addEventListener('keydown', event => {
      if (event.target !== stage || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const index = event.key === 'Home' ? 0 : event.key === 'End' ? items.length - 1 : active + (event.key === 'ArrowRight' ? 1 : -1);
      goTo(items[Math.max(0, Math.min(items.length - 1, index))].dataset.galleryItem);
    });
    let width = stage.clientWidth;
    const resize = 'ResizeObserver' in window ? new ResizeObserver(() => {
      if (width === stage.clientWidth) return;
      width = stage.clientWidth;
      goTo(items[active].dataset.galleryItem, 'auto');
    }) : null;
    resize?.observe(stage);
    galleries.set(gallery, {goTo, resize});
    const dialog = gallery.querySelector('[data-gallery-lightbox]');
    dialog?.addEventListener('close', () => {
      document.documentElement.classList.remove('gallery-zoom-open');
      const activeLink = gallery.querySelector('.gallery-item[aria-hidden="false"] [data-gallery-zoom]');
      (activeLink || dialog._opener || stage).focus({preventScroll: true});
    });
    dialog?.addEventListener('keydown', event => {
      if (dialog.classList.contains('is-zoomed') || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      renderGalleryZoom(gallery, Number(dialog.dataset.imageIndex) + (event.key === 'ArrowRight' ? 1 : -1));
    });
    dialog?.querySelector('[data-gallery-zoom-image]')?.addEventListener('click', () => toggleGalleryZoom(dialog));
  }
  function renderGalleryZoom(gallery, index) {
    const links = [...gallery.querySelectorAll('.gallery-stage [data-gallery-zoom]')];
    const dialog = gallery.querySelector('[data-gallery-lightbox]');
    index = Math.max(0, Math.min(links.length - 1, index));
    const link = links[index];
    if (!dialog || !link) return;
    const image = dialog.querySelector('[data-gallery-zoom-image]');
    const original = link.querySelector('img');
    image.src = link.href; image.alt = original.alt;
    image.width = Number(original.getAttribute('width')) || 1500; image.height = Number(original.getAttribute('height')) || 1500;
    dialog.dataset.imageIndex = String(index);
    dialog.querySelector('[data-gallery-zoom-label]').textContent = original.alt || 'صورة المنتج';
    const count = dialog.querySelector('[data-gallery-zoom-count]');
    const previous = dialog.querySelector('[data-gallery-zoom-step="-1"]');
    const next = dialog.querySelector('[data-gallery-zoom-step="1"]');
    if (count) count.textContent = `${index + 1} / ${links.length}`;
    if (previous) previous.disabled = index === 0;
    if (next) next.disabled = index === links.length - 1;
    toggleGalleryZoom(dialog, false);
    showMedia(link.closest('[data-gallery-item]').dataset.galleryItem, gallery, 'auto');
  }
  function toggleGalleryZoom(dialog, zoomed = !dialog.classList.contains('is-zoomed')) {
    dialog.classList.toggle('is-zoomed', zoomed);
    const button = dialog.querySelector('[data-gallery-magnify]');
    button.setAttribute('aria-pressed', String(zoomed));
    button.textContent = zoomed ? 'تصغير −' : 'تكبير +';
    dialog.querySelector('[data-gallery-zoom-canvas]').scrollTo(0, 0);
  }
  function showMedia(id, gallery = document.querySelector('[data-gallery]'), behavior) {
    if (!gallery || !gallery.querySelector(`[data-gallery-item="${CSS.escape(id)}"]`)) return;
    if (galleries.has(gallery)) { galleries.get(gallery).goTo(id, behavior); return; }
    gallery.querySelectorAll('[data-gallery-item]').forEach(el => {
      el.hidden = el.dataset.galleryItem !== id;
      if (el.hidden) el.querySelectorAll('video').forEach(v => v.pause());
      el.querySelectorAll('[data-demo-gif]').forEach(img => {
        img.src = el.hidden || img.dataset.paused === 'true' ? img.dataset.poster : img.dataset.gif;
      });
    });
    gallery.querySelectorAll('[data-gallery-show]').forEach(el => { el.setAttribute('aria-pressed', String(el.dataset.galleryShow === id)); });
  }
  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-variant]')) syncVariant(event.target.closest('[data-product-form]'));
  });
  document.addEventListener('click', async (event) => {
    const target = event.target.closest('button,a,summary');
    if (!target) return;
    if (target.matches('[data-gallery-zoom]')) {
      const gallery = target.closest('[data-gallery]');
      const dialog = gallery.querySelector('[data-gallery-lightbox]');
      if (typeof dialog?.showModal !== 'function') return;
      event.preventDefault();
      const links = [...gallery.querySelectorAll('.gallery-stage [data-gallery-zoom]')];
      dialog._opener = target;
      renderGalleryZoom(gallery, links.indexOf(target));
      dialog.showModal();
      document.documentElement.classList.add('gallery-zoom-open');
      dialog.querySelector('[data-gallery-close]').focus();
      return;
    }
    if (target.matches('[data-gallery-close]')) { target.closest('dialog').close(); return; }
    if (target.matches('[data-gallery-magnify]')) { toggleGalleryZoom(target.closest('dialog')); return; }
    if (target.matches('[data-gallery-zoom-step]')) {
      const dialog = target.closest('dialog');
      renderGalleryZoom(target.closest('[data-gallery]'), Number(dialog.dataset.imageIndex) + Number(target.dataset.galleryZoomStep));
      return;
    }
    if (target.matches('[data-demo-toggle]')) {
      const img = target.closest('[data-demo]')?.querySelector('[data-demo-gif]');
      if (!img) return;
      const paused = img.dataset.paused !== 'true';
      img.dataset.paused = String(paused);
      img.src = paused ? img.dataset.poster : img.dataset.gif;
      target.setAttribute('aria-pressed', String(paused));
      target.textContent = paused ? 'تشغيل الحركة' : 'إيقاف الحركة';
      return;
    }
    if (target.matches('[data-open-cart]') && drawerEnabled) { event.preventDefault(); await openCart(target); return; }
    if (target.matches('[data-close-cart]')) {
      if (target.tagName === 'BUTTON') event.preventDefault();
      document.getElementById('CartDrawer')?.close(); return;
    }
    if (target.matches('[data-gallery-show]')) { showMedia(target.dataset.galleryShow, target.closest('[data-gallery]')); return; }
    if (target.matches('[data-qty]')) {
      const qty = target.closest('[data-quantity]')?.querySelector('input');
      if (!qty) return;
      const min = Number(qty.min) || 1, step = Number(qty.step) || 1, max = qty.max ? Number(qty.max) : Infinity;
      qty.value = String(Math.min(max, Math.max(min, (Number(qty.value) || min) + Number(target.dataset.qty) * step)));
      qty.dispatchEvent(new Event('change', { bubbles: true })); return;
    }
    if (target.matches('[data-cart-change]')) {
      if (cartBusy) return;
      cartBusy = true;
      const dialog = document.getElementById('CartDrawer');
      const error = dialog?.querySelector('[data-cart-error]'); setError(error, '');
      dialog?.querySelectorAll('button').forEach(button => { if (!button.matches('[data-close-cart]')) button.disabled = true; });
      try {
        const response = await fetch(`${root}cart/change.js`, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: target.dataset.key, quantity: Number(target.dataset.value), sections: ['df-cart-drawer'], sections_url: window.location.pathname }) });
        const result = await response.json();
        if (!response.ok) { setError(error, 'ما قدرنا نعدّل الكمية. جرّب كمية أقل أو حدّث السلة.'); return; }
        setCount(result.item_count);
        if (!replaceDrawer(result.sections?.['df-cart-drawer'])) { window.location.assign(cartURL); return; }
        showDrawer();
      } catch { setError(error, 'تعذر التأكد من التعديل. حدّث السلة قبل المحاولة مرة ثانية.'); }
      finally { cartBusy = false; dialog?.querySelectorAll('button').forEach(button => { button.disabled = false; }); }
      return;
    }
    if (target.closest('.mobile-menu nav')) target.closest('.mobile-menu').open = false;
  });
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!form.matches('[data-product-form]') || !drawerEnabled || (event.submitter && !event.submitter.matches('[data-add]'))) return;
    event.preventDefault();
    if (form.dataset.busy === 'true' || cartBusy) return;
    if (!form.reportValidity()) return;
    const button = form.querySelector('[data-add]');
    if (button?.disabled) return;
    const error = form.querySelector('[data-product-error]'); setError(error, '');
    const data = new FormData(form); data.append('sections', 'df-cart-drawer'); data.append('sections_url', window.location.pathname);
    form.dataset.busy = 'true'; cartBusy = true; drawerOpener = button;
    button.disabled = true; button.setAttribute('aria-busy', 'true'); button.querySelector('[data-add-label]').textContent = 'جاري الإضافة…';
    try {
      const response = await fetch(`${root}cart/add.js`, { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' }, body: data });
      const result = await response.json();
      if (!response.ok) { setError(error, 'تعذر إضافة هذا الخيار بالكمية المطلوبة. راجع الكمية والتوفر وجرب مرة ثانية.'); return; }
      if (!replaceDrawer(result.sections?.['df-cart-drawer'])) { window.location.assign(cartURL); return; }
      showDrawer();
      try { const cartResponse = await fetch(`${root}cart.js`, { credentials: 'same-origin' }); if (cartResponse.ok) setCount((await cartResponse.json()).item_count); } catch { /* Cart drawer already shows the confirmed server result. */ }
    } catch { setError(error, 'تعذر التأكد من إضافة المنتج. راجع السلة قبل إعادة المحاولة.'); }
    finally { form.dataset.busy = 'false'; cartBusy = false; button.removeAttribute('aria-busy'); syncVariant(form); }
  });
  document.addEventListener('close', (event) => {
    if (event.target.id === 'CartDrawer' && event.target.dataset.replacing !== 'true' && drawerOpener?.isConnected) drawerOpener.focus();
  }, true);
  document.addEventListener('click', (event) => {
    const dialog = event.target;
    if (dialog.id === 'CartDrawer' && dialog.open) {
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
    }
  });
  let stickyObserver;
  function initialize(scope = document) {
    scope.querySelectorAll('[data-demo-gif]').forEach(img => {
      if (img.dataset.paused != null) return;
      const paused = reduceMotion();
      img.dataset.paused = String(paused);
      setDemoSource(img, !img.closest('[data-gallery-item]')?.hidden);
      const toggle = img.closest('[data-demo]')?.querySelector('[data-demo-toggle]');
      if (toggle) {
        toggle.setAttribute('aria-pressed', String(paused));
        toggle.textContent = paused ? 'تشغيل الحركة' : 'إيقاف الحركة';
      }
    });
    scope.querySelectorAll('[data-gallery-carousel]').forEach(initializeGallery);
    scope.querySelectorAll('[data-product-form]').forEach(form => syncVariant(form, new URL(window.location.href).searchParams.has('variant')));
    const sticky = document.querySelector('[data-sticky-buy]');
    const product = document.getElementById('df-product');
    stickyObserver?.disconnect();
    if (sticky && product && 'IntersectionObserver' in window) {
      stickyObserver = new IntersectionObserver(([entry]) => { sticky.classList.toggle('is-hidden', entry.isIntersecting); }, { threshold: 0.1 });
      stickyObserver.observe(product);
    }
  }
  document.querySelectorAll('nav a[href]').forEach(link => {
    const url = new URL(link.href, location.href);
    if (url.origin === location.origin && !url.hash && url.pathname === location.pathname && url.searchParams.get('view') === new URL(location.href).searchParams.get('view')) link.setAttribute('aria-current', 'page');
  });
  initialize();
  document.addEventListener('shopify:section:load', () => initialize());
})();
